import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { COMPANY } from "@/constants/company";
import { clearCookieConsent } from "@/components/CookieBanner";

/**
 * Single consistent legal footer with brand, copyright, and required legal links.
 * Used on landing, login/register, legal pages, public share.
 */
export default function LegalFooter() {
  return (
    <footer className="border-t border-[#E5E2D9] bg-[#F1EFE7]" data-testid="legal-footer">
      <div className="container mx-auto px-4 md:px-8 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex flex-col gap-2">
          <Logo small />
          <div className="text-xs text-[#5C6B61] max-w-md">
            © {new Date().getFullYear()} {COMPANY.name} — {COMPANY.appName} ist ein Service für Standortdaten im GaLaBau.
          </div>
        </div>
        <nav className="flex flex-wrap gap-x-5 gap-y-2 text-xs text-[#5C6B61]">
          <Link to="/" className="hover:text-[#1A2F24]" data-testid="footer-link-home">Start</Link>
          <Link to="/impressum" className="hover:text-[#1A2F24]" data-testid="footer-link-impressum">Impressum</Link>
          <Link to="/datenschutz" className="hover:text-[#1A2F24]" data-testid="footer-link-datenschutz">Datenschutz</Link>
          <button
            type="button"
            data-testid="footer-link-cookies"
            onClick={() => { clearCookieConsent(); window.location.reload(); }}
            className="hover:text-[#1A2F24] text-left"
          >
            Cookie-Einstellungen
          </button>
          <Link to="/login" className="hover:text-[#1A2F24]" data-testid="footer-link-login">Anmelden</Link>
        </nav>
      </div>
      <div className="border-t border-[#E5E2D9]">
        <div className="container mx-auto px-4 md:px-8 py-5 flex items-center gap-4">
          <img
            src="/images/efre-sab-logo.png"
            alt="Kofinanziert von der Europäischen Union – Freistaat Sachsen"
            className="h-20 w-auto"
          />
        </div>
      </div>
    </footer>
  );
}
